export enum FeatureFlags {
  TIP_CALCULATOR = 'tip_calculator', // Enables tip calculator make payments
  TIP_CALCULATOR_RULES = 'tip_calculator_rules', // Enables tip calculator rules creation and editing
  TIP_CALCULATOR_AI_RULES_SUGGEST = 'tip_calculator_ai_rules_suggest', // Enables AI-powered tip calculator rules suggestions
  AI_DAY_SEGMENTS_SUGGEST = 'ai_day_segments_suggest', // Enables AI-powered day segments suggestions
  MAINTENANCE_MODE = 'maintenance_mode', // Enables maintenance mode for the application
  CALCULATOR_ORIGINAL_SETTINGS = 'calculator_original_settings', // Gates the calculator settings comparison and the original-settings recalculation
}
